import styled from "styled-components";

const StyledCheckboxArea = styled.div`
    display: flex;
    margin-left: -16px;

    & > div > label {
        padding-left: 0.5rem !important;
    }
`;

const StyledTableContent = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
`;

const StyledTableContainer = styled.div`
    width: 500px;
`;

const StyledTable = styled.table`
    padding: 16px;
    background-color: #fff;
    margin-bottom: 16px;
`;

const StyledTableTitle = styled.td`
    font-size: 16px;
    font-weight: bold;
    padding: 16px 0 10px 0;
`;

const StyledTableSubtitle = styled.td`
    font-size: 16px;
    font-weight: bold;
    padding: 24px 0 10px 0;
`;

const StyledTableInfo = styled.td`
    font-size: 15px;
    font-weight: normal;
    text-align: left;
    padding-left: 24px;
`;

const StyledTableInfoTitle = styled.td`
    font-size: 15px;
    font-weight: bold;
    text-align: left;
    padding-left: 24px;
`;

const StyledTableValue = styled.td`
    font-size: 15px;
    font-weight: normal;
    text-align: right;
    padding-right: 24px;
    white-space: nowrap;
`;

const StyledTableValueMarked = styled.td`
    font-size: 15px;
    font-weight: normal;
    text-align: right;
    color: #a8071a;
    padding-right: 24px;
    white-space: nowrap;
`;

const StyledTableLink = styled.td`
    padding: 12px 0 20px 0;

    & > button {
        display: block;
        margin: auto;
    }
`;

export default {
    StyledCheckboxArea,
    StyledTableContent,
    StyledTableContainer,
    StyledTable,
    StyledTableTitle,
    StyledTableSubtitle,
    StyledTableInfo,
    StyledTableInfoTitle,
    StyledTableValue,
    StyledTableValueMarked,
    StyledTableLink,
};
